import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/user';

import Select from 'react-select';

import {api} from '../../actions/_request';

const roles = [
    {label: 'Tecnico', value: 1},
    {label: 'Supervisor', value: 2},
    {label: 'Coordinador', value: 3},
    {label: 'Administrador', value: 4}
];

const roles_supervisor = [
    {label: 'Tecnico', value: 1},
    {label: 'Supervisor', value: 2},
   
];
const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };


class ClienteModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            usuario:
            {
                id:null,
                name:"",
                email:"",
                password:"",
                departamento:1,
                rol:1,
                cliente_id:0,
                comision1:0,
                comision2:0,
                comision3:0,
                comision4:0,
                comision5:0,
                meta:0,
                base:0,
                comision_produccion:0,
                lista:[],
                permisos:[
                {
                    modulo_id:1,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:2,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
               {
                    modulo_id:3,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:4,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:5,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:6,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:7,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:8,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:9,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:10,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:11,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:12,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
            ],

            },
            departamentos:[],
            departamentos_tabla:[],
            action: 'save_usuario',
            activeTab: '1',
            


        };

            this.toggle_tab= this.toggle_tab.bind(this);
            this.handleInputChange2 = this.handleInputChange2.bind(this);
            this.CrearUsuario = this.CrearUsuario.bind(this);
            this.handleChangeDepartamento = this.handleChangeDepartamento.bind(this);
            this.handleChangeRol = this.handleChangeRol.bind(this);
            this.handleInputChangetable = this.handleInputChangetable.bind(this);
            this.handleInputChangePermisos = this.handleInputChangePermisos.bind(this);
       
    }
    toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }
    componentDidMount()
    {
         
        let prospectoid = this.props.prospectoid;
        let self = this;
       
        
         api().get('/departamentos')
        .then(function(response)
        {
            self.setState({
                departamentos : response.data
            });
           
        })


        
      
        if(prospectoid > 0 && prospectoid != self.state.usuario.id)
        {

            api().get(`users/${prospectoid}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {  

                    let usuario=response.data;
                    if(Object.keys(usuario.permisos).length <= 0){
                        usuario.permisos=[
                {
                    modulo_id:1,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:2,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
               {
                    modulo_id:3,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:4,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:5,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:6,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:7,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:8,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:9,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:10,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:11,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:12,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
            ]; 
                      
                       
                     }  


                    
                              
                    self.setState({
                        usuario: usuario,
                        action: 'update_usuario'
                    });
                    // console.log(response.data);
                }

            });
            
        }
        else if(prospectoid == null)
        {            
            self.resetUser();
        }

    }

    componentWillReceiveProps(nextProps)
    {

    }

    

    resetUser(){
        let self = this;

        api().get('/sin_supervisor')
        .then(function(response)
        {
            self.setState({
                usuario:
            {
                id:null,
                name:"",
                email:"",
                password:"",
                departamento:1,
                rol:1,
                cliente_id:0,
                comision1:0,
                comision2:0,
                comision3:0,
                comision4:0,
                comision5:0,
                meta:0,
                base:0,
                comision_produccion:0,
                lista:response.data,
                permisos:[
                {
                    modulo_id:1,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:2,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
               {
                    modulo_id:3,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:4,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:5,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:6,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:7,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:8,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:9,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:10,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:11,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
                {
                    modulo_id:12,
                    menu:0,
                    altas:0,
                    bajas:0,
                    cambios:0,
                    reportes:0,
                },
            ],
               

            },
            action: 'save_usuario',
            });
           
        })

    }

    handleInputChangePermisos(event,name,modulo) {
        let {usuario} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;

        usuario.permisos[modulo][name] = value;
        // console.log('campo---->',name);
        // console.log('value---->',value);

        
        this.setState({
            usuario : usuario
        });
    }



   
    handleInputChange2(event) {
        let {usuario} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value='0';
            if(target.checked)
                value='1';
        }

        usuario[name] = value;
        // console.log('campo---->',name);
        // console.log('value---->',value);

        if(name=="supervisor" && value==false){
            // console.log('entro---->');
            for (var i = usuario.lista.length - 1; i >= 0; i--) {
                usuario.lista[i].check=false;
            }
        }
        this.setState({
            usuario : usuario
        });
    }
    handleInputChangetable(row) {
        let {usuario} = this.state;
        let lista = this.state.usuario.lista;
        let bandera=0;
        let i =row.index;
        lista[i].check=!lista[i].check;
        usuario.lista=lista;

        this.setState({
            usuario : usuario
        });


      

       
    }
    handleChangeDepartamento(departamento)
    {
        let {usuario}         = this.state;
        usuario.departamento    = departamento.value;
        this.setState({usuario: usuario});
    }
    handleChangeRol(departamento)
    {
        let {usuario}         = this.state;
        usuario.rol    = departamento.value;
        console.log('rol--->',departamento.value);
        if(departamento.value==4){
            usuario.permisos=[
                {
                    modulo_id:1,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:2,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
               {
                    modulo_id:3,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:4,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:5,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:6,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:7,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:8,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:9,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:10,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:11,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
                {
                    modulo_id:12,
                    menu:1,
                    altas:1,
                    bajas:1,
                    cambios:1,
                    reportes:1,
                },
            ];
        }
        this.setState({usuario: usuario});
    }
      objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                   // console.log('valor---->',valor)
                     if(key!=="password"&&key!=="lista"&&key!=="email"&&key!='permisos'){
                        objeto[key] = String(objeto[key]).toUpperCase();
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     }
                         
                     
                   // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }
    CrearUsuario(evt)
    {
        evt.preventDefault();
        let {usuario,permisos} = this.state;
        let self = this;
        let save=true;
        let dato="";
              
        
            let check = ['name','email','password'];

            for(let i in check) {

            let key = check[i];

            let value = usuario[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                if(key==='name')dato="Nombre";
                if(key==='password')dato="Contraseña";
                if(key==='email')dato="Correo";
                break;
            }
                
            }

            if(parseInt(usuario.meta)<=0){
                 save = false;
                dato="Meta";
            } else if(parseInt(usuario.base)<=0){
                 save = false;
                dato="Base";
            }
            let id =usuario.id;

            var items           = [];  

            usuario.lista.some(function(obj) {
                var check = obj.check;
                
                if(check)
                items.push({                    
                    departamento_id:obj.id,
                    usuario_id:id,                                  
                });

            });
            usuario.lista=items;
             // console.log("Lista: ",items);

              var lista_permisos           = [];  

              usuario.permisos.some(function(obj) {
           

                lista_permisos.push({                    
                    modulo_id:obj.modulo_id,
                    menu:obj.menu,
                    altas:obj.altas,
                    bajas:obj.bajas,
                    cambios:obj.cambios,
                    reportes:obj.reportes,                                  
                });

            });
            usuario.permisos=lista_permisos;
             console.log("Lista de Permisos---> ",lista_permisos);
                
             
           
              
        usuario=this.objeto_mayusculas(usuario);
  
   if(save){
            api().post(`/usuario_validar`, usuario)
            .then(function(response)
            {
                let validacion=response.data.validacion;
                let encontrado=response.data.encontrado[0];

                if(validacion||(parseInt(encontrado.id)===parseInt(usuario.id) )){

                  self.props[self.state.action](usuario, () => {
                        swal({
                            title: 'Usuario',
                            text: 'Usuario Guardado correctamente!',
                            type: 'success',
                            // showCancelButton: true,
                            // confirmButtonColor: '#3085d6',
                            // cancelButtonColor: '#d33',
                            confirmButtonText: 'Continue!'
                        }).then((result) => {
                            if (result.value) {
                                // swal(
                                //  'Deleted!',
                                //  'Your file has been deleted.',
                                //  'success'
                                //  )
                               self.props.toggle();
                                self.resetUser();
                            }
                        })
                    });
       }else{
                    swal("Oops..", "El Correo ya Esta Registrado");
                }
            });

       }else{
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }


    }

   

    render()
    {

        let {usuario,departamentos,permisos}=this.state;
        let rol =parseInt( this.props.auth.user.rol);
        let edit=false;
        let supervisor=true;
       if (usuario.id!==null){

        if(rol!==4)
        edit=true;

        if(rol>1)
        supervisor=false;



       }
           
      
        
        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                  <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Datos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle_tab('2'); }}
                        >
                         Parametros
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '3' })}
                          onClick={() => { this.toggle_tab('3'); }}
                        >
                         Permisos
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                         <div className="mt-2">
                      <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className>Departamento:</label>
                                <Select
                                    placeholder=""
                                    type="text"
                                    name="departamento_id"
                                    options={departamentos}
                                    value={parseInt(usuario.departamento)}
                                    onChange={ this.handleChangeDepartamento } 
                                    clearable={false}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className>Rol:</label>
                                <Select
                                    placeholder=""
                                    type="text"
                                    name="tipo_id"
                                    options={(rol===4||usuario.id!==null)? roles : roles_supervisor} 
                                    value={parseInt(usuario.rol) || ""}
                                    onChange={ this.handleChangeRol }
                                    disabled={edit}
                                    clearable={false}
                                />
                            </div>
                        </div>


                            <div className="col-md-8">
                            <FormGroup>
                                <Label>Nombre</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="name"
                                    value={usuario.name}
                                    onChange={ this.handleInputChange2}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Correo</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="email"
                                    value={usuario.email}
                                    onChange={ this.handleInputChange2}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Password</Label>
                                    <Input
                                    placeholder=""
                                    type="password"
                                    name="password"
                                    value={usuario.password}
                                    onChange={ this.handleInputChange2}
                                    />
                            </FormGroup>
                        </div>

                      

                        
                        </div>
                        <br/><br/><br/>                              
                            </div>
                           
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col sm="12">

                          <div className="row mt-2">
                           <div className="col-md-3">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className>Comisiones %</label>
                                                <InputGroup>
                                                <InputGroupAddon>1-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="comision1"
                                                        value={(usuario.comision1)}
                                                        onChange={this.handleInputChange2}
                                                        disabled={supervisor}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">                                                
                                                <InputGroup>
                                                <InputGroupAddon>2-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="comision2"
                                                        value={(usuario.comision2)}
                                                        onChange={this.handleInputChange2}
                                                        disabled={supervisor}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">                                               
                                                <InputGroup>
                                                <InputGroupAddon>3-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="comision3"
                                                        value={(usuario.comision3)}
                                                        onChange={this.handleInputChange2}
                                                        disabled={supervisor}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">                                               
                                                <InputGroup>
                                                <InputGroupAddon>4-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="comision4"
                                                        value={(usuario.comision4)}
                                                        onChange={this.handleInputChange2}
                                                        disabled={supervisor}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">                                               
                                                <InputGroup>
                                                <InputGroupAddon>5-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="comision5"
                                                        value={(usuario.comision5)}
                                                        onChange={this.handleInputChange2}
                                                        disabled={supervisor}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        

                                        
                                        
                                        </div>

                                    </div>



                                    <div className="col-md-3">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className> Meta</label>
                                                <InputGroup>
                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="meta"
                                                        value={(usuario.meta)}
                                                        onChange={this.handleInputChange2}
                                                        disabled={supervisor}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                       
                                        <div className="col-12">
                                             <div className="form-group">
                                                <label className> Base</label>
                                                <InputGroup>
                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="base"
                                                        value={(usuario.base)}
                                                        onChange={this.handleInputChange2}
                                                        disabled={supervisor}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        
                                        <div className="col-12">
                                             <div className="form-group">
                                                <label className> % Comision Prod.</label>
                                                <InputGroup>                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="comision_produccion"
                                                        value={(usuario.comision_produccion)}
                                                        onChange={this.handleInputChange2}
                                                        disabled={supervisor}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        
                                       
                                        

                                        
                                        
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-12 pt-2">
                                                <div className="form-group mt-4">
                                                <label >
                                                    <input type="checkbox"
                                                    name="supervisor" 
                                                    checked={usuario.supervisor === "0" ? false : true}
                                                    onChange={this.handleInputChange2}
                                                    disabled={supervisor}
                                                    />&nbsp;&nbsp;Supervisor
                                                </label>
                                                </div>
                                            </div>
                                            <div className="col-md-12 pt-2">
                                            <ReactTable
                                            data      = {usuario.lista}
                                            className = "-striped -highlight"
                                            columns   = {[
                                            {Header: 'Departamento', accessor: 'departamento'},
                                            {                                                
                                                filterable: false,
                                                sortable: false,
                                                maxWidth:20,
                                                Cell: (row) =>
                                                {
                                                    return(
                                                    <div className="text-right">
                                                        <input type="checkbox"
                                                    name="actualizar" 
                                                    checked={row.original.check}
                                                     onChange={ () => this.handleInputChangetable(row) }
                                                    
                                                     disabled={(usuario.supervisor==='0'||supervisor)}
                                                    />

                                                    </div>
                                                    )
                                                }
                                            }

                                            ]}
                                            filterable 
                                             defaultPageSize={5} 
                                             pageSizeOptions= {[5]}
                                            defaultFilterMethod={filterCaseInsensitive}

                                            />
                                            </div>
                                        </div>
                                    </div>
                          </div>
                                               
                          </Col>
                        </Row>
                      </TabPane>
                        <TabPane tabId="3">
                        <Row>
                            <Col sm="12">
                                <div className="row mt-5">
                                    <div className="col-md-5 div_titulo mr-2">
                                        <h1><span>Catalogos</span></h1>
                                        <div className="row mt-2">
                                             <div className='col-8'>
                                             </div>
                                             <div className='col-1'>
                                                <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                    <label className="">A </label>
                                                 </div>
                                             </div>
                                            <div className='col-1'>
                                                <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                    <label className="">B </label>
                                                 </div>
                                             </div>
                                            <div className='col-1'>
                                                <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                    <label className="">C </label>
                                                 </div>
                                             </div>
                                            <div className='col-1'>
                                                <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                    <label className="">R </label>
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row mt-2">
                                             <div className='col-8'>
                                                 <div className="form-group m-0 text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[0].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',0) } }
                                                        /> &nbsp;&nbsp; Articulos
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[0].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',0) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[0].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',0) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[0].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',0) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[0].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',0) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row ">
                                             <div className='col-8'>
                                                 <div className="form-group m-0  text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[1].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',1) } }
                                                        /> &nbsp;&nbsp; Clientes
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[1].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',1) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[1].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',1) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[1].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',1) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[1].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',1) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row ">
                                             <div className='col-8'>
                                                 <div className="form-group m-0  text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[2].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',2) } }
                                                        /> &nbsp;&nbsp; Proveedores
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[2].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',2) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[2].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',2) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[2].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',2) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[2].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',2) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row ">
                                             <div className='col-8'>
                                                 <div className="form-group m-0 text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[5].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',5) } }
                                                        /> &nbsp;&nbsp; Usuarios
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[5].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',5) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[5].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',5) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[5].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',5) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[5].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',5) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>                                               
                                    </div>
                                    <div className="col-md-6 div_titulo mr-2">
                                        <h1><span>Movimientos</span></h1>
                                        <div className="row mt-2">
                                             <div className='col-8'>
                                             </div>
                                             <div className='col-1'>
                                                <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                    <label className="">A </label>
                                                 </div>
                                             </div>
                                            <div className='col-1'>
                                                <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                    <label className="">B </label>
                                                 </div>
                                             </div>
                                            <div className='col-1'>
                                                <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                    <label className="">C </label>
                                                 </div>
                                             </div>
                                            <div className='col-1'>
                                                <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                    <label className="">R </label>
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row mt-2">
                                             <div className='col-8'>
                                                 <div className="form-group m-0 text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[6].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',6) } }
                                                        /> &nbsp;&nbsp; Facturacion
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[6].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',6) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[6].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',6) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[6].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',6) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[6].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',6) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row ">
                                             <div className='col-8'>
                                                 <div className="form-group m-0  text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[7].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',7) } }
                                                        /> &nbsp;&nbsp; Compras
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[7].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',7) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[7].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',7) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[7].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',7) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[7].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',7) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row ">
                                             <div className='col-8'>
                                                 <div className="form-group m-0  text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[8].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',8) } }
                                                        /> &nbsp;&nbsp; C/A de Clientes
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[8].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',8) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0 text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[8].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',8) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[8].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',8) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[8].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',8) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row ">
                                             <div className='col-8'>
                                                 <div className="form-group m-0 text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[9].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',9) } }
                                                        /> &nbsp;&nbsp; C/A de Proveedores
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[9].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',9) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[9].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',9) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[9].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',9) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[9].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',9) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row ">
                                             <div className='col-8'>
                                                 <div className="form-group m-0 text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[10].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',10) } }
                                                        /> &nbsp;&nbsp; Almacen
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[10].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',10) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[10].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',10) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[10].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',10) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[10].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',10) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>
                                         <div className="row ">
                                             <div className='col-8'>
                                                 <div className="form-group m-0 text-left ">
                                                     <label className="">                                                       
                                                        <input type="checkbox"
                                                        name="factura_electronica" 
                                                        checked={usuario.permisos[11].menu}
                                                         onChange={ (input) => { this.handleInputChangePermisos(input, 'menu',11) } }
                                                        /> &nbsp;&nbsp; Inventarios Fisico
                                                        </label>
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[11].altas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'altas',11) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[11].bajas}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'bajas',11) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[11].cambios}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'cambios',11) } }
                                                     />
                                                 </div>
                                             </div>
                                             <div className='col-1'>
                                                 <div className="form-group m-0  text-left ajuste_checkbox_parametros ">
                                                     <input type="checkbox"
                                                     name="factura_electronica" 
                                                     checked={usuario.permisos[11].reportes}
                                                      onChange={ (input) => { this.handleInputChangePermisos(input, 'reportes',11) } }
                                                     />
                                                 </div>
                                             </div>
                                         </div>                                               
                                    </div>
                                </div>                   
                            </Col>
                        </Row>
                        </TabPane>                                     
                    </TabContent>
                        </CardBlock>
                    </Card>
                </div>
                   
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.user.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.CrearUsuario} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user : state.user,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(ClienteModal)


// WEBPACK FOOTER //
// ./src/views/user/Modal.js